/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

/*
* Sorting for Data Table
* */

import Vue from 'vue'

interface HeaderData {
  value: string,
  sortable: boolean
}

export default Vue.extend({
  data () {
    return {
      headers: [] as Array<HeaderData>,
      sortParams: '',
      sortableColumns: [] as Array<string>
    }
  },
  mounted () {
    if (this.sortableColumns.length) {
      this.headers.forEach(header => {
        if (this.sortableColumns.includes(header.value)) {
          header.sortable = true
        }
      })
    }
  },
  methods: {
    fetchItems () {},
    sortBy (sortBy: string, sortDesc: boolean) {
      if (sortBy) {
        this.sortParams = `&orderBy=${sortBy}&orderDir=${sortDesc}`
      } else {
        this.sortParams = ''
      }
      this.fetchItems()
    }
  }
})
